import { useEffect, useState } from "react";
import axios from "axios";
import { Event } from "interfaces/events";
import { StudentUser } from "interfaces/users";
import { Company } from "interfaces/companies";

const useEventName = (id?: string) => {
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    axios
      .get<Event>(`/events/admin-events/${id}/`)
      .then(response => setName(response.data.name))
      .catch(() => setName(null));
  }, [id]);

  return name;
};

const useStudentName = (id?: string) => {
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    axios
      .get<StudentUser>(`/students/${id}/`)
      .then(response => setName(`${response.data.first_name} ${response.data.last_name}`))
      .catch(() => setName(null));
  }, [id]);

  return name;
};

// Function to retrive company name
const useCompanyName = (id?: string) => {
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    axios
      .get<Company>(`/companies/${id}/`)
      .then(response => setName(response.data.name))
      .catch(() => setName(null));
  }, [id]);

  return name;
};

export { useEventName, useStudentName, useCompanyName };
